import endPoints from './endPoints'
import axios from '../../../../../../../services/axios'

const { store } = endPoints

export const setStore = async (data) => (
	await axios.post(store, data)
)
